// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__YQsYe","ButtonDark":"Button_ButtonDark__eHY_6"};